// src/components/UserManagement.js
import React, { useState, Suspense } from 'react';
import { Box, Tabs, Tab, Typography, CircularProgress, Paper } from '@mui/material';

// Lazy-loaded components
const AdminList = React.lazy(() => import("../Components/Lists/AdminList"));
const StudentList = React.lazy(() => import("../Components/Lists/StudentList"));
const TutorList = React.lazy(() => import("../Components/Lists/TutorList"));

// Helper component for tab panel content (remains the same)
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `user-tab-${index}`,
    'aria-controls': `user-tabpanel-${index}`,
  };
}

const UserManagement = () => {
  // Local state for the active tab, always defaults to 0 (Admins)
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
        textColor="inherit"
        indicatorColor="secondary"
        value={value} onChange={handleChange} aria-label="user type tabs" variant="scrollable" scrollButtons="auto">
          <Tab label="Admins" {...a11yProps(0)} />
          <Tab label="Students" {...a11yProps(1)} />
          <Tab label="Tutors" {...a11yProps(2)} />
        </Tabs>
      </Box>

      {/* Suspense fallback for lazy loading */}
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
            }}
          >
            <CircularProgress />
            <Typography variant="h6" ml={2}>Loading data...</Typography>
          </Box>
        }
      >
        <TabPanel value={value} index={0}>
          <AdminList />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <StudentList />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <TutorList />
        </TabPanel>
      </Suspense>
    </Paper>
  );
};

export default UserManagement;